import { IProfileElementDataV1, IProfileElementV1 } from '../models/AndromeTV.types';
import { Backend } from '../Backend';

export class ProfileApi {
  /**
   * Retrieve a list of all profiles from the backend
   */
  static list(backend: Backend): Promise<IProfileElementV1[]> {
    const url = backend.makeUrl('aa/v1/profile');
    return backend.getJson(url, backend.bearer) as Promise<IProfileElementV1[]>;
  }

  /**
   * Fetch the profile with the specified profileId from the backend
   */
  static profile(backend: Backend, profileId: string): Promise<IProfileElementV1> {
    const url = backend.makeUrl(`aa/v1/profile/${encodeURIComponent(profileId)}`);
    return backend.getJson(url, backend.bearer) as Promise<IProfileElementV1>;
  }

  /**
   * create a new profile
   */
  static create(backend: Backend, profile: IProfileElementDataV1): Promise<IProfileElementV1> {
    const url = backend.makeUrl('aa/v1/profile');
    return backend.postJson(url, profile, backend.bearer) as Promise<IProfileElementV1>;
  }

  /**
   * update an existing profile
   */
  static update(backend: Backend, profileId: string, profile: IProfileElementDataV1): Promise<IProfileElementV1> {
    const url = backend.makeUrl(`aa/v1/profile/${encodeURIComponent(profileId)}`);
    return backend.putJson(url, profile, backend.bearer) as Promise<IProfileElementV1>;
  }

  /**
   * Delete a profile
   */
  static delete(backend: Backend, profileId: string): Promise<Response> {
    const url = backend.makeUrl(`aa/v1/profile/${encodeURIComponent(profileId)}`);
    return backend.delete(url, backend.bearer) as Promise<Response>;
  }

  /**
   * Switch a profile
   */
  static switch(backend: Backend, profileId: string): Promise<Response> {
    const url = backend.makeUrl(
      // @ts-ignore
      `aa/v1/device/${backend.sessionInfo.device.id}/profile/${encodeURIComponent(profileId)}`
    );
    return backend.putJson(url, undefined, backend.bearer) as Promise<Response>;
  }
}
